/** Calendar-day arithmetic in UTC avoids daylight-saving and locale drift. */
const dayPattern = /^\d{4}-\d{2}-\d{2}$/;
export function shiftTripDate(value:string, offset:number):string {
  if(!dayPattern.test(value))return "";
  const parsed=new Date(`${value}T12:00:00Z`);
  if(Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0,10)!==value)return "";
  parsed.setUTCDate(parsed.getUTCDate()+offset);
  return parsed.toISOString().slice(0,10);
}
/** Days one before and one after a journey are enabled, inclusive. */
export function tripDateWindow(start:string,end:string):{min?:string;max?:string} {
  if(!start||!end||start>end||!shiftTripDate(start,0)||!shiftTripDate(end,0))return {};
  return {min:shiftTripDate(start,-1),max:shiftTripDate(end,1)};
}
export function isWithinTripWindow(date:string,start:string,end:string):boolean {
  if(!date)return true;
  const {min,max}=tripDateWindow(start,end);
  return Boolean(shiftTripDate(date,0)&&(!min||date>=min)&&(!max||date<=max));
}
